import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import InputField from "components/fields/InputField";

import { API_URL } from "config/api";
import AuthCard from "./components/AuthCard";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "Something went wrong");
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard>
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Reset Password
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your new password below.
        </p>

        {success ? (
          <div className="rounded-xl bg-green-50 p-4 dark:bg-navy-800">
            <p className="mb-4 text-sm font-medium text-green-700 dark:text-green-400">
              Your password has been updated successfully.
            </p>
            <Link
              to="/login"
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              &larr; Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <InputField
              variant="auth"
              extra="mb-3"
              label="New Password*"
              placeholder="Min. 6 characters"
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Confirm Password*"
              placeholder="Repeat your new password"
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            {error && (
              <p className="mb-3 text-sm font-medium text-red-500">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading || !token}
              className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              {loading ? "Updating..." : "Update Password"}
            </button>

            {!token && (
              <p className="mt-3 text-sm font-medium text-red-500">
                Invalid reset link. Please request a new one.
              </p>
            )}
          </form>
        )}
    </AuthCard>
  );
}
